import { fromJS, Map } from 'immutable';
import { OPEN_ADD_CONTENT_MODAL, OPEN_ADD_CONTENT_MODAL_DATA, ADD_CONTENT_MODAL, OPEN_DELETE_STIMULUS_MODAL, DELETE_STIMULUS_MODAL, OPEN_MOVE_IMMUTABLE_MODAL, MOVE_IMMUTABLE_MODAL, OPEN_MODAL, CLOSE_MODAL } from '@instructure/quiz-common';
export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : fromJS({
    OPEN_ADD_CONTENT_MODAL_DATA: {
      allowStimulusCreation: false,
      modalOpen: false,
      position: 0,
      quizId: '',
      stimulusId: ''
    }
  });
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case OPEN_DELETE_STIMULUS_MODAL:
      return state.set('isOpen', DELETE_STIMULUS_MODAL);
    case OPEN_ADD_CONTENT_MODAL:
      return state.set('isOpen', ADD_CONTENT_MODAL).set(OPEN_ADD_CONTENT_MODAL_DATA, Map(action.payload));
    case OPEN_MOVE_IMMUTABLE_MODAL:
      return state.set('isOpen', MOVE_IMMUTABLE_MODAL);
    case OPEN_MODAL:
      return state.set('isOpen', action.payload.title).set('options', Map(action.payload.options));
    case CLOSE_MODAL:
      return state.set('isOpen', false);
    default:
      return state;
  }
});